export default __webpack_public_path__ + "static/media/pdf.99fe7521.svg";